<template>

  <div>

    <!-- <list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      @refetchData="refetchData"
    /> -->

    <!-- Bulk Update Modal -->
    <b-modal
      id="modal-bulk-update-signatory"
      ref="bulkUpdateModal"
      cancel-variant="outline-secondary"
      ok-title="Simpan Perubahan"
      cancel-title="Batal"
      centered
      title="Update Massal Penandatangan"
      @ok="handleBulkUpdateSubmit"
    >
      <b-form>
        <!-- Tipe User -->
        <b-form-group
          label="Pilih Kategori User"
          label-for="bulk-tipe-user"
        >
          <v-select
            v-model="bulkUpdateData.tipe_user"
            id="bulk-tipe-user"
            :options="tipeUserOptions"
            :reduce="val => val.value"
            placeholder="Pilih Kategori"
          />
        </b-form-group>

        <!-- Penandatangan -->
        <b-form-group
          label="Pilih Penandatangan Baru"
          label-for="bulk-penandatangan"
        >
          <v-select
            v-model="bulkUpdateData.penandatangan_id"
            id="bulk-penandatangan"
            :options="penandatanganOptions"
            :reduce="val => val.value"
            placeholder="Cari Nama / NIP / Email..."
          >
            <template #option="{ label }">
              <span>{{ label }}</span>
            </template>
          </v-select>
          <small class="text-muted">Cari berdasarkan Nama, NIP/NUP, atau Email</small>
        </b-form-group>
      </b-form>
    </b-modal>

    <!-- Filters -->
    <list-filters
      :trigger-filter.sync="triggerFilter"
      :data-filter.sync="dataFilter"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <!-- <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              /> -->
              <b-button
                variant="primary"
                :to="{ name: 'pegawai-baru'}"
                class="mr-1"
              >
                <span class="text-nowrap">Tambah Pegawai</span>
              </b-button>
              <b-button
                variant="success"
                @click="openBulkUpdateModal"
              >
                <span class="text-nowrap">Update Penandatangan Massal</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchDatas"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: User -->
        <!-- <template #cell(name)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.name)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
                title="Lihat Profil"
              />
            </template>
          </b-media>
        </template> -->

        <!-- <template #cell(email)="data">
          <b-media vertical-align="center">
            {{ data.item.email }}
          </b-media>
        </template>

        <template #cell(role)="data">
          <b-media vertical-align="center">
            {{ data.item.v1 }}
          </b-media>
        </template> -->

          <!-- <template #cell(status)="data">
          <b-media vertical-align="center">
            <b-badge pill :variant="'light-success'" v-if="data.item.email_verified_at !== null">Aktif</b-badge>
            <b-badge pill :variant="'light-danger'" v-if="data.item.email_verified_at === null">Tidak Aktif</b-badge>
          </b-media>
        </template> -->

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="d-flex">
            <b-button
            class="mr-1 mb-1 btn-icon btn btn-relief-primary"
            variant="info"
            :to="{ name: 'setting-pegawai', params: { uuid: data.item.uuid } }"
            title="Ubah Data"
          >
            <feather-icon icon="EditIcon" />
          </b-button>

          <!-- <b-button
            class="mb-1 btn-icon btn btn-relief-primary"
            variant="danger"
            @click="deleteData(data.item.uuid)"
            title="Delete"
          >
            <feather-icon icon="TrashIcon" />
          </b-button> -->
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Menampilkan {{ dataMeta.from }} per {{ dataMeta.to }} dari {{ dataMeta.of }} data </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  deleteDosen,
} from '@/connection-api/master'
import {
  getAllMasterUUID,
  updateBulkSignatory,
} from '@/connection-api/pengajuan-cuti/api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/connection-api/list-pegawai/storeModule'
import useList from '@/connection-api/list-pegawai/list'
// import listAddNew from './ListAddNew.vue'
import listFilters from './ListFilters.vue'
import { BForm, BFormGroup, BModal } from 'bootstrap-vue'

export default {
  components: {
    listFilters,
    // listAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BModal,
    BForm,
    BFormGroup,
    // BDropdown,
    // BDropdownItem,
    BPagination,
    BBadge,

    vSelect,
  },
  data() {
    return {
      bulkUpdateData: {
        tipe_user: null,
        penandatangan_id: null,
      },
      tipeUserOptions: [
        { label: 'Staff', value: '1' },
        { label: 'Dosen / Kordinator', value: '2' },
        { label: 'Lainnya (Security / Shift)', value: '3' },
      ],
      penandatanganOptions: [],
    }
  },
  async mounted() {
    this.fetchPenandatanganOptions()
  },
  methods: {
    deleteData(uuid){
      if(window.confirm('Apakah anda yakin?'))
      {
        var data = {
          uuid: uuid,
        }
        store.dispatch('list-pegawai/deleteData', data)
          .then(response => {
            this.makeToast('success', 'Delete Data Status Hasil Sidang Berhasil Dilakukan')
            this.refetchData()
          })
          .catch(error => {
          })
      }
    },
    makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: title || 'Status Hasil Sidang',
        variant,
        solid: true,
        autoHideDelay: 3000,
        enableHtml: true,
        allowHtml: true,
      })
    },
    async fetchPenandatanganOptions() {
      const response = await getAllMasterUUID()
      this.penandatanganOptions = response.data.data.penandatangan.map(item => ({
        label: `${item.nama} (${item.nip_nup || '-'}) - ${item.email}`,
        value: item.id,
      }))
    },
    openBulkUpdateModal() {
      this.bulkUpdateData.tipe_user = null
      this.bulkUpdateData.penandatangan_id = null
      this.$refs.bulkUpdateModal.show()
    },
    async handleBulkUpdateSubmit(bvModalEvent) {
      bvModalEvent.preventDefault()

      if (!this.bulkUpdateData.tipe_user || !this.bulkUpdateData.penandatangan_id) {
        this.makeToast('warning', 'Silakan lengkapi semua pilihan.', 'Peringatan')
        return
      }

      try {
        const response = await updateBulkSignatory(this.bulkUpdateData)
        if (response.success) {
          this.makeToast('success', response.message, 'Berhasil')
          this.$refs.bulkUpdateModal.hide()
          this.refetchData()
        } else {
          this.makeToast('danger', response.message, 'Gagal')
        }
      } catch (error) {
        this.makeToast('danger', 'Terjadi kesalahan sistem.', 'Error')
      }
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'list-pegawai'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)

    const {
      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      triggerFilter,
      dataFilter,
    } = useList()

    return {

      // Sidebar
      isAddNewUserSidebarActive,

      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      triggerFilter,
      dataFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
